import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function Tapentadol100mgUS() {
  const navigate = useNavigate();
  const [quantity, setQuantity] = useState(1);
  const [cartCount, setCartCount] = useState(0);
  const [selectedPackage, setSelectedPackage] = useState('180pills');

  const product = {
    id: 15,
    name: 'Tapentadol 100mg',
    category: 'Pain Relief',
    price: 540.00,
    image: 'https://public.readdy.ai/ai/img_res/b4b8ecec585c2b1bc0332d284f07c28e.jpg',
    rating: 4.8,
    reviews: 198,
    inStock: true,
    description: 'Tapentadol 100mg is a powerful pain reliever used to treat moderate to severe acute pain. It works through two mechanisms: as an opioid pain reliever and by affecting norepinephrine reuptake, providing effective pain management for various conditions. Fast US to US shipping available.',
    activeIngredient: 'Tapentadol 100mg',
    manufacturer: 'Janssen Pharmaceuticals',
    dosage: '100mg tablets',
    packaging: '30 tablets per bottle',
    shippingType: 'US to US'
  };

  const packages = {
    '180pills': { pills: 180, price: 540 },
    '360pills': { pills: 360, price: 1050 },
    '540pills': { pills: 540, price: 1550 }
  };

  const currentPackage = packages[selectedPackage as keyof typeof packages];

  useEffect(() => {
    const updateCartCount = () => {
      try {
        const savedCart = localStorage.getItem('cart');
        if (savedCart) {
          const cart = JSON.parse(savedCart);
          const count = cart.reduce((sum: number, item: any) => sum + item.quantity, 0);
          setCartCount(count);
        }
      } catch (error) {
        console.error('Error reading cart from localStorage:', error);
        setCartCount(0);
      }
    };
    
    updateCartCount();
    window.addEventListener('storage', updateCartCount);
    return () => window.removeEventListener('storage', updateCartCount);
  }, []);

  const addToCart = () => {
    try {
      const savedCart = localStorage.getItem('cart');
      const cart = savedCart ? JSON.parse(savedCart) : [];
      
      if (!currentPackage) {
        console.error('No package selected');
        return;
      }

      const cartProduct = {
        ...product,
        price: currentPackage.price,
        packageSize: currentPackage.pills,
        packageType: selectedPackage
      };
      
      const existingItem = cart.find((item: any) => 
        item.id === product.id && item.packageType === selectedPackage
      );
      
      if (existingItem) {
        existingItem.quantity += quantity;
      } else {
        cart.push({ ...cartProduct, quantity });
      }
      
      localStorage.setItem('cart', JSON.stringify(cart));
      const newCount = cart.reduce((sum: number, item: any) => sum + item.quantity, 0);
      setCartCount(newCount);
      window.dispatchEvent(new Event('storage'));
    } catch (error) {
      console.error('Error adding to cart:', error);
    }
  };

  const relatedProducts = [
    {
      id: 5,
      name: 'Soma 350mg',
      price: 200.00,
      image: 'https://readdy.ai/api/search-image?query=professional%20soma%20carisoprodol%20muscle%20relaxer%20tablets%20in%20pharmaceutical%20packaging%20on%20clean%20white%20surface%20medical%20product%20photography%20soft%20lighting%20high%20quality%20shot&width=300&height=300&seq=5&orientation=squarish',
      link: '/products/soma-350mg'
    },
    {
      id: 11,
      name: 'Ibuprofen 400mg',
      price: 120.00,
      image: 'https://readdy.ai/api/search-image?query=ibuprofen%20pain%20relief%20tablets%20in%20modern%20pharmaceutical%20packaging%20on%20clean%20white%20surface%20professional%20medical%20product%20photography%20soft%20lighting%20high%20quality%20shot&width=300&height=300&seq=301&orientation=squarish',
      link: '/products/ibuprofen'
    },
    {
      id: 7,
      name: 'Zolpidem 10mg',
      price: 540.00,
      image: 'https://readdy.ai/api/search-image?query=professional%20zolpidem%20sleep%20aid%20tablets%20in%20pharmaceutical%20packaging%20on%20clean%20white%20surface%20medical%20product%20photography%20soft%20lighting%20high%20quality%20shot&width=300&height=300&seq=7&orientation=squarish',
      link: '/products/zolpidem-10mg'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <nav className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="text-2xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>MediCare</Link>
            </div>
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/" className="text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">Home</Link>
              <Link to="/all-products" className="text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">Products</Link>
              <a href="/#contact" className="text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap cursor-pointer">Contact</a>
            </div>
            <div className="flex items-center space-x-4">
              <Link to="/cart" className="w-10 h-10 flex items-center justify-center text-gray-700 hover:text-teal-600 transition-colors cursor-pointer relative">
                <i className="ri-shopping-cart-line text-xl"></i>
                <span className="absolute -top-1 -right-1 bg-teal-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">{cartCount}</span>
              </Link>
              <Link to="/auth" className="w-10 h-10 flex items-center justify-center text-gray-700 hover:text-teal-600 transition-colors cursor-pointer">
                <i className="ri-user-line text-xl"></i>
              </Link>
            </div>
          </div>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          <div>
            <img src={product.image} alt={product.name} className="w-full rounded-2xl shadow-lg object-cover object-top" />
          </div>
          <div>
            <div className="flex items-center gap-3 mb-2">
              <p className="text-sm text-teal-600 font-semibold">{product.category}</p>
              <span className="px-3 py-1 bg-blue-100 text-blue-600 text-xs font-semibold rounded-full">US to US Shipping</span>
            </div>
            <h1 className="text-4xl font-bold text-gray-900 mb-4">{product.name}</h1>
            <div className="flex items-center mb-6">
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className={`${i < Math.floor(product.rating) ? 'ri-star-fill' : 'ri-star-line'} text-yellow-400 text-lg`}></i>
                ))}
              </div>
              <span className="ml-2 text-gray-600">({product.reviews} reviews)</span>
            </div>
            <p className="text-4xl font-bold text-gray-900 mb-6">${currentPackage?.price || product.price}</p>
            
            <div className="mb-6">
              <h3 className="font-semibold text-gray-900 mb-3">Select Package</h3>
              <div className="grid grid-cols-3 gap-3">
                {Object.entries(packages).map(([key, pkg]) => (
                  <button
                    key={key}
                    onClick={() => setSelectedPackage(key)}
                    className={`p-4 rounded-lg border-2 transition-all cursor-pointer ${
                      selectedPackage === key
                        ? 'border-teal-600 bg-teal-50'
                        : 'border-gray-200 hover:border-teal-300'
                    }`}
                  >
                    <div className="text-lg font-bold text-gray-900">{pkg.pills} pills</div>
                    <div className="text-sm text-teal-600 font-semibold">${pkg.price}</div>
                  </button>
                ))}
              </div>
            </div>

            <div className="border-t pt-6 mb-6">
              <p className="text-sm text-gray-600"><strong>SKU:</strong> MED{product.id.toString().padStart(6, '0')}</p>
            </div>

            <div className="flex items-center gap-4 mb-6">
              <div className="flex items-center border border-gray-300 rounded-lg">
                <button onClick={() => setQuantity(Math.max(1, quantity - 1))} className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                  <i className="ri-subtract-line"></i>
                </button>
                <span className="px-6 py-2 border-x border-gray-300">{quantity}</span>
                <button onClick={() => setQuantity(quantity + 1)} className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                  <i className="ri-add-line"></i>
                </button>
              </div>
              <button onClick={addToCart} className="flex-1 bg-teal-600 text-white px-8 py-3 rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer font-semibold">
                <i className="ri-shopping-cart-line mr-2"></i>
                Add to Cart
              </button>
            </div>

            <div className="flex items-center gap-4 text-sm text-gray-600 mb-6">
              <div className="flex items-center">
                <i className="ri-shield-check-line text-teal-600 mr-2"></i>
                <span>100% Genuine</span>
              </div>
              <div className="flex items-center">
                <i className="ri-truck-line text-teal-600 mr-2"></i>
                <span>Fast Shipping</span>
              </div>
              <div className="flex items-center">
                <i className="ri-lock-line text-teal-600 mr-2"></i>
                <span>Secure Payment</span>
              </div>
            </div>

            <p className="text-gray-600 mb-6">{product.description}</p>

            <div className="bg-gray-50 rounded-lg p-6">
              <h3 className="font-semibold text-gray-900 mb-4">Product Information</h3>
              <ul className="space-y-2">
                <li className="flex items-center">
                  <i className="ri-check-line text-teal-600 mr-2"></i>
                  <span className="text-gray-700"><strong>Active Ingredient:</strong> {product.activeIngredient}</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-teal-600 mr-2"></i>
                  <span className="text-gray-700"><strong>Manufacturer:</strong> {product.manufacturer}</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-teal-600 mr-2"></i>
                  <span className="text-gray-700"><strong>Dosage:</strong> {product.dosage}</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-teal-600 mr-2"></i>
                  <span className="text-gray-700"><strong>Packaging:</strong> {product.packaging}</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-truck-line text-teal-600 mr-2"></i>
                  <span className="text-gray-700"><strong>Shipping:</strong> {product.shippingType}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <footer className="bg-gray-900 text-gray-300 py-12 mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            <div>
              <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>MediCare</h3>
              <p className="text-gray-400">Your trusted online pharmacy for quality medications.</p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Home</Link></li>
                <li><Link to="/all-products" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Products</Link></li>
                <li><a href="/#contact" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Contact</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Categories</h4>
              <ul className="space-y-2">
                <li><span className="text-gray-400">Pain Relief</span></li>
                <li><span className="text-gray-400">Sleep Aid</span></li>
                <li><span className="text-gray-400">Muscle Relaxers</span></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Contact</h4>
              <ul className="space-y-2">
                <li className="text-gray-400">Email: info@medicare.com</li>
                <li className="text-gray-400">Phone: (555) 123-4567</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 text-center text-gray-400">
            <p>&copy; 2024 MediCare. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer">Powered by Readdy</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
